enum PlaySessionEventActionTypes {
  COMPLETE = "complete",
  STATUS = "status",
  START = "start",
  CREATE = "create",
  REQUEST = "request",
}

export default PlaySessionEventActionTypes;
